const state = {
    trainers: {
        TrainerList: [],
        stats: [],
        total: 0,
        page: 0,
        limit: 25,
        isLoading: false,
        searchTerm: ""
    }
}
export default state;